import hero from 'assets/png/hero.png'
import CarouselTicketBg from 'assets/png/carousel_ticket_bg1.svg'
import CarouselTicketBg2 from 'assets/png/carousel_ticket_bg2.svg'
import GiftClose from 'assets/png/gift_close.png'
import GiftOpen from 'assets/png/gift_open.png'

const Preload = () => (
  <>
    <link rel="preload" as="image" href={hero} />
    <link rel="preload" as="image" href={CarouselTicketBg} />
    <link rel="preload" as="image" href={CarouselTicketBg2} />
    <link rel="preload" as="image" href={GiftClose} />
    <link rel="preload" as="image" href={GiftOpen} />
  </>
)

export default Preload
